import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import LookListContentHeader from "./lookListContentHeader";
import LookListMain from "./lookListMain";
import WithCartAnimationsChecker from "../hocs/withCartAnimationsChecker";

const LookListContent = (props) => {

  const {onBackClick} = props;

  return (
    <WithCartAnimationsChecker>
      {() => (
        <section className="ll-body__right">
          <LookListContentHeader onBackClick={onBackClick}/>
          <LookListMain/>
        </section>
      )}
    </WithCartAnimationsChecker>
  )
};

LookListContent.propTypes = {
  onBackClick: PropTypes.func.isRequired
}

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LookListContent)
